import React from 'react';
import PropTypes from 'prop-types';
import ExclamationCircle from 'react-icons/lib/fa/exclamation-circle';
import uuid from 'uuid/v4';
import classnames from 'classnames';

import Tooltip from './Tooltip';

class IconHelp extends React.Component {
  render() {
    const { placement = 'auto-start', className, innerClassName } = this.props;
    const id = `${innerClassName}-${uuid()}`;

    return (
      <span
        id={id}
        className={classnames('tooltip-container', className)}
      >
        <Tooltip
          id={id}
          placement={placement}
          innerClassName={innerClassName}
          {...this.props}
        />
        <ExclamationCircle />
      </span>

    );
  }
}

IconHelp.propTypes = {
  // XXX See reactstrap doc for dull documentation https://reactstrap.github.io/components/tooltips/
  text: PropTypes.string.isRequired,
  placement: PropTypes.string,
};

export default IconHelp;



// WEBPACK FOOTER //
// ./src/IconHelp.js